import { isEmpty } from 'lodash';

function saveLoginData(session, data, email) {
  const brand = !isEmpty(data.brand) ? data.brand.toLowerCase() : process.env.VUE_APP_BRAND;

  session.set('email', email);
  session.set('brand', brand);
  session.set('urlDealerPrivacy', data.urlDealerPrivacy);
  session.set('privacy', data.privacy);
  session.set('transferData', data.transferData);

  return {
    brand,
    showTutorial: data.tutorial,
    showNoticePrivacy: data.privacy,
  };
}

export default saveLoginData;
